import { useMutation, useQueryClient } from '@tanstack/react-query'
import { retryNotificationTask } from 'api/highnote/notificationTasks'
import { highnoteKeys } from './keys'

export const useRetryNotificationTaskMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (eventId: number) => retryNotificationTask(eventId),
    onSettled: async () =>
      queryClient.invalidateQueries({
        queryKey: highnoteKeys.failedNotificationTasksRoot,
      }),
  })
}
